var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 37,
    viewBox: "0 0 38 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1854 3.9155C17.9016 2.37012 20.0984 2.37012 20.8146 3.91551L24.1981 11.2163C24.4892 11.8444 25.0843 12.2773 25.7716 12.3607L33.7532 13.3301C35.4413 13.5351 36.1196 15.6198 34.8753 16.7789L28.981 22.2696C28.4755 22.7405 28.2488 23.439 28.3814 24.117L29.9285 32.0265C30.2552 33.6971 28.4786 34.9862 26.9918 34.1573L19.9739 30.2447C19.3685 29.9072 18.6315 29.9072 18.0261 30.2447L11.0082 34.1573C9.52142 34.9862 7.74475 33.6971 8.07151 32.0265L9.61858 24.117C9.7512 23.439 9.52451 22.7405 9.019 22.2696L3.12475 16.7789C1.88041 15.6198 2.55867 13.5351 4.24684 13.3301L12.2284 12.3607C12.9157 12.2773 13.5108 11.8444 13.8019 11.2163L17.1854 3.9155Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1054 10.7958L21.7219 3.49503C20.6476 1.17695 17.3524 1.17694 16.2781 3.49502L12.8946 10.7958C12.7491 11.1098 12.4515 11.3263 12.1079 11.368L4.12628 12.3374C1.59402 12.6449 0.57663 15.7719 2.44313 17.5107L8.33739 23.0013C8.59014 23.2368 8.70349 23.586 8.63718 23.925L7.09011 31.8345C6.59997 34.3404 9.26498 36.2741 11.4952 35.0307L18.5131 31.1181C18.8158 30.9494 19.1842 30.9494 19.4869 31.1181L26.5048 35.0307C28.735 36.2741 31.4 34.3404 30.9099 31.8345L29.3628 23.925C29.2965 23.586 29.4099 23.2368 29.6626 23.0013L35.5569 17.5107C37.4234 15.7719 36.406 12.6449 33.8737 12.3374L25.8921 11.368C25.5485 11.3263 25.2509 11.1098 25.1054 10.7958Z",
    stroke: "black",
    strokeOpacity: 0.3,
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.221cb8d28a373760707bbcd4a726f5b6.svg";
export { ForwardRef as ReactComponent };